import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import type { FieldFormProps, AttachmentFile } from '@helpcenter/field-types';
import * as mixins from '@helpcenter/styles/src/mixins';
import { FormattedMessage } from 'react-intl';
import { FieldBase } from 'view/common/fields/field-base';
import { token } from '@atlaskit/tokens';
import i18n from './messages';

export interface Props extends FieldFormProps<AttachmentFile[]> {
	mediaApiError?: string;
}

const RequestCreateAttachmentFieldError: React.FunctionComponent<Props> = ({
	label,
	description,
	required,
	errorMessage,
	mediaApiError,
	id,
}) => {
	return (
		<FieldBase
			htmlFor={id}
			label={label}
			description={description}
			required={required}
			errorMessage={errorMessage}
		>
			<Error>{mediaApiError || <FormattedMessage {...i18n.genericError} />}</Error>
		</FieldBase>
	);
};

export default RequestCreateAttachmentFieldError;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Error = styled.div`
	${mixins.borderRadius};
	border: ${token('border.width', '1px')} solid ${token('color.border.danger', '#BF2600')};
	width: 100%;
	padding: ${token('space.100', '8px')};
	text-align: center;
`;
